module.exports = __webpack_public_path__ + "static/media/HIGH_ENERGY.69a4bdaf.svg";